import React from 'react';

type BadgeVariant = 'active' | 'overdue' | 'pending' | 'paid' | 'flagged' | 'cleared' | 'held' | 'filed' | 'compliant' | 'non-compliant' | 'under-review';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

const variantMap: Record<BadgeVariant, string> = {
  active: 'lra-badge-active',
  compliant: 'lra-badge-active',
  paid: 'lra-badge-paid',
  cleared: 'lra-badge-paid',
  filed: 'lra-badge-paid',
  overdue: 'lra-badge-overdue',
  'non-compliant': 'lra-badge-overdue',
  pending: 'lra-badge-pending',
  held: 'lra-badge-pending',
  flagged: 'lra-badge-flagged',
  'under-review': 'lra-badge-flagged',
};

const labelMap: Record<BadgeVariant, string> = {
  active: 'Active',
  compliant: 'Compliant',
  paid: 'Paid',
  cleared: 'Cleared',
  filed: 'Filed',
  overdue: 'Overdue',
  'non-compliant': 'Non-Compliant',
  pending: 'Pending',
  held: 'Held',
  flagged: 'Flagged',
  'under-review': 'Under Review',
};

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const cls = variantMap[variant] ?? 'lra-badge-pending';
  const text = label ?? labelMap[variant];
  return (
    <span
      className={`${cls} ${size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-xs px-2 py-1'} rounded-full font-semibold inline-flex items-center gap-1`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full inline-block"
        style={{
          backgroundColor:
            variant === 'active' || variant === 'compliant'
              ? 'var(--success-text)'
              : variant === 'overdue' || variant === 'non-compliant'
              ? 'var(--danger-text)'
              : variant === 'pending' || variant === 'held'
              ? 'var(--warning-text)'
              : variant === 'flagged' || variant === 'under-review'
              ? '#be185d' :'#1d4ed8',
        }}
      />
      {text}
    </span>
  );
}